import React from 'react';

const ArrowTriangleRightIcon = ({ width = 7, height = 12, fill = '#FFFFFF' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.666992 11.7881V0.0446777L6.53873 5.91641L0.666992 11.7881Z" fill={fill} />
    </svg>
  );
};

export default ArrowTriangleRightIcon;
